import { render, staticRenderFns } from "./RequestsPage.vue?vue&type=template&id=347c2af0&scoped=true"
import script from "./RequestsPage.vue?vue&type=script&lang=js"
export * from "./RequestsPage.vue?vue&type=script&lang=js"
import style0 from "./RequestsPage.vue?vue&type=style&index=0&id=347c2af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c2af0",
  null
  
)

export default component.exports